export class TodoPlacementTestController {
  private taskDetails: any;
  private placementTask: any;
  private placementData: any;
  private placementLocations: any;
  private expectItem: any;
  private hasPlacementBands: boolean;
  constructor(private appConfigModel: any) {
    const SERVER_PLACEMENT_BAND_STRATEGY = `PlacementBand`;
    this.hasPlacementBands =
      this.appConfigModel.getConfigProperty('cat-devreq_assignment_strategy') === SERVER_PLACEMENT_BAND_STRATEGY;
  }
}

export class TodoPlacementTestComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/todo_placement_test/todo_placement_test.html';
  public controller: any = TodoPlacementTestController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    taskDetails: '<',
    placementTask: '<',
    placementData: '<',
    placementLocations: '<',
    expectItem: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/todo_placement_test/todo_placement_test.ts